import React, { FC, memo } from 'react'
import { FluidImage, HStack } from '../index'
import { PhoneSpecsCondensed as Phone } from '../../phones'
import { Box, Center, Flex, Tag } from '@chakra-ui/react'
import i18next from 'i18next'
import { PhoneSpecsCondensed } from './phone-specs-condensed'

export interface PhoneCondensedCardProps {
  phone: Phone
  onClick: (phoneId: Phone['phoneId']) => void
}

// const translateMemory = (memoryName: string) => {
//   const data = memoryName?.match(/(?<dataValue>\d+)(\s)?(?<dataUnit>MB|GB|TB)/i)
//   if (data?.groups?.dataUnit && data?.groups?.dataValue) {
//     const translatedUnit = i18next.t(`common_${data?.groups?.dataUnit}`)
//     memoryName = `${data?.groups?.dataValue} ${translatedUnit}`
//   }

//   return memoryName
// }

// const showPhoneConditionTag = (condition: string) => {
//   switch (condition) {
//     case PhoneCondition.REFURBISHED:
//       return i18next.t('like-new') as string
//     case PhoneCondition.REFURBISHED_B:
//       return i18next.t('very-good') as string
//     case PhoneCondition.REFURBISHED_C:
//       return i18next.t('good') as string
//     default:
//       return ''
//   }
// }

const managePressedKey =
  (onClick: { (phoneId: number): void; (arg0: any): void }, phoneId: number) => (e: { key: string }) => {
    if (e.key === 'Enter') {
      onClick(phoneId)
    }
  }

/**
 * There should probably be a more generic "card" component, but I can't see a pattern, plus, some cards in the UI
 * have a hover state and others don't. This one requires a label, others don't. Can't see the pattern yet, so this
 * guy is split for readability purposes in <PhoneList />.
 */
export const PhoneCardCondensed: FC<PhoneCondensedCardProps> = memo(({ phone, onClick }) => {
  return (
    <HStack
      role="button"
      aria-label={phone.name}
      width="full"
      maxWidth={290}
      maxHeight={120}
      borderRadius="default"
      justifyContent="space-between"
      padding={4}
      marginBottom={4}
      border={2}
      borderStyle="solid"
      borderColor="grey"
      userSelect="none"
      cursor="pointer"
      marginX={1}
      _hover={{
        borderColor: 'brand',
      }}
      label={phone.name}
      onClick={() => onClick(phone.phoneId)}
      onKeyPress={managePressedKey(onClick, phone.phoneId)}
      position="relative"
      _focus={{
        borderColor: 'brand',
        boxShadow: '0 0 0 3px #5bce4c',
      }}
      tabIndex={0}
    >
      <Flex alignItems="center" width="full" height="100%">
        <Center width={20} height={20} flex={1.2}>
          <FluidImage src={`https://www.planhub.ca/img/phone/${phone.slug}.png`} alt={phone.name} />
        </Center>
        <Box flex={2.5} alignSelf={'flex-start'}>
          <PhoneSpecsCondensed name={phone.name} brand={phone.brandName} />
        </Box>
        <Box flex={1} alignSelf={'flex-start'}>
          <Box textAlign="right">
            {phone.avgModelPriceTier !== undefined &&
              phone.avgModelPriceTier !== null &&
              [1, 2, 3, 4, 5].includes(phone.avgModelPriceTier) && (
                <Tag
                  colorScheme="darkGrey"
                  color="darkGrey"
                  variant="outline"
                  borderWidth="1px"
                  borderColor="darkGrey"
                  fontSize="16px"
                  fontWeight={'bold'}
                  top={0}
                  right={0}
                  width={'fit-content'}
                  textAlign="center"
                  // backgroundColor="green.50"
                  whiteSpace="nowrap"
                  display="inline-flex"
                  alignItems="center"
                >
                  {i18next.t(`common_price-tier-${phone.avgModelPriceTier}`) as string}
                </Tag>
              )}
          </Box>
        </Box>
      </Flex>
      <Box position={'absolute'} left={'110px'} bottom={3.5}>
        <Box
          borderWidth="1px"
          borderRadius="md"
          fontSize="12px"
          bottom={0}
          right={0}
          minW={'60px'}
          backgroundColor="#f3f9e8"
          color="brand"
          boxShadow="#83bd43 0 0 0 1px inset"
          zIndex={1}
          display="inline-flex"
          whiteSpace="nowrap"
          justifyContent="center"
          alignItems="center"
          visibility={phone.hasNew ? 'visible' : 'hidden'}
        >
          {i18next.t('phone-new') as string}
          {/* {showPhoneConditionTag(phone.modelCondition) as string} */}
        </Box>
        {phone.hasRefurbished && (
          <Box
            borderWidth="1px"
            borderRadius="md"
            fontSize="12px"
            bottom={0}
            left={0}
            minW={'90px'}
            backgroundColor="#fbe9fe"
            color="#75147c"
            // boxShadow="#75147c 0 0 0 1px inset"
            zIndex={1}
            display="inline-flex"
            whiteSpace="nowrap"
            justifyContent="center"
            alignItems="center"
            marginLeft={2}
          >
            {i18next.t('phone-refurbished') as string}
            {/* {showPhoneConditionTag(phone.modelCondition) as string} */}
          </Box>
        )}
      </Box>
    </HStack>
  )
})
